// Generated with tools/create-component.js
import React, { useEffect, useState } from "react";
import { CmsContent, Container, Icon, Image } from "components";
import { BackgroundColourEnum, ContainerSpacingEnum, ContainerWidthEnum } from "utils";
import { VideoPlayerQueryFragment } from "codegen";
import "./VideoPlayer.scss";
import AOS from "aos";
import "aos/dist/aos.css";
import classNames from "classnames";
import Modal from "react-modal";
import ReactPlayer from "react-player/youtube";

interface VideoPlayerProps {
  data: VideoPlayerQueryFragment;
}

Modal.defaultStyles.overlay.zIndex = "99";

export const VideoPlayer: React.FC<VideoPlayerProps> = ({
  data: {
    introduction,
    placeholder,
    playIconBelow,
    videoLink,
    backgroundColour,
    containerWidth,
    containerSpacing,
    sectionId,
  },
}): JSX.Element => {
  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <Container
      className="video-player"
      backgroundColour={BackgroundColourEnum[backgroundColour]}
      containerWidth={ContainerWidthEnum[containerWidth]}
      containerSpacing={ContainerSpacingEnum[containerSpacing]}
      sectionId={sectionId}
    >
      {introduction && (
        <div className="video-player__intro" data-aos="fade-in">
          <CmsContent content={introduction} />
        </div>
      )}
      <div
        className={classNames({
          "video-player__icon-below": playIconBelow,
          "video-player__icon-overlay": !playIconBelow,
        })}
      >
        <Image src={placeholder} className="video-player__placeholder" />
        {playIconBelow && (
          <button className="video-player__play-button" onClick={() => setIsOpen(true)}>
            <Icon name="Play" size={2} />
            <span className="video-player__play-button__text">Play Video</span>
          </button>
        )}

        {!playIconBelow && (
          <div onClick={() => setIsOpen(true)}>
            <Icon name="PlayNarrow" size={10} className="video-player__play-icon" />
          </div>
        )}
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        className="modal__wrapper"
        overlayClassName="modal__overlay"
      >
        <button onClick={() => setIsOpen(false)} className="modal__close">
          <Icon name="Close" size={2} />
        </button>
        <div className="modal__video">
          <ReactPlayer url={videoLink} className="react-player" width="100%" height="100%" />
        </div>
      </Modal>
    </Container>
  );
};
